import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type ThreadMarkReadParamsDTO = {
  uuid: string
}

export const useThreadMarkReadMutation = () =>
  useMutation<any, ErrorDTO, ThreadMarkReadParamsDTO>({
    mutationFn: async (params) => {
      try {
        const res = await client.post(`/thread/markread/${params.uuid}`)

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
